import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { _getUserDetails, _userLogin, _getUserOrganisations, _userLoginV2, _getSiteList } from "../shared/httpservice/apis";
const initialState = {
    userLogin: {
        loading: false,
        response: null,
        hasError: false,
        error: {},
    },
    userDetails: {
        loading: false,
        response: null,
        hasError: false,
        error: {},
    },
    userOrganisations: {
        loading: false,
        response: null,
        hasError: false,
        error: {},
    },
    userSiteList: {
        loading: false,
        response: null,
        hasError: false,
        error: {},
        cachedPages: {},
        currentPage: 1,
    },
    mapId: "",
    siteName: "",
};
export const userLoginAction = createAsyncThunk("auth/userLogin", async (data, { rejectWithValue }) => {
    try {
        const response = await _userLogin(data);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const getUserDetailsAction = createAsyncThunk('auth/userDetails', async (_, { rejectWithValue }) => {
    try {
        const response = await _getUserDetails();
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const getUserOrganisationsAction = createAsyncThunk('auth/getUserOrganisations', async (data, { rejectWithValue }) => {
    try {
        const response = await _getUserOrganisations(data);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const userLoginV2Action = createAsyncThunk('auth/userLoginV2', async (data, { rejectWithValue }) => {
    try {
        const response = await _userLoginV2(data);
        return { data: response.data };
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const getSiteListAction = createAsyncThunk('auth/getSiteList', async (params, { rejectWithValue }) => {
    try {
        // Always fetch fresh data from API
        const response = await _getSiteList(params);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        getMapId: (state, action) => {
            state.mapId = action.payload;
        },
        getSiteName: (state, action) => {
            state.siteName = action.payload;
        },
        resetAuthSlice: () => initialState,
        setSiteListFromCache: (state, action) => {
            const pageNumber = action.payload;
            const cachedPage = state.userSiteList.cachedPages[pageNumber];
            if (cachedPage) {
                state.userSiteList.response = cachedPage;
                state.userSiteList.currentPage = pageNumber + 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(userLoginAction.pending, (state) => {
            state.userLogin.loading = true;
            state.userLogin.response = null;
            state.userLogin.hasError = false;
            state.userLogin.error = {};
        })
            .addCase(userLoginAction.fulfilled, (state, action) => {
            state.userLogin.loading = false;
            state.userLogin.response = action.payload;
            state.userLogin.hasError = false;
            state.userLogin.error = {};
        })
            .addCase(userLoginAction.rejected, (state, action) => {
            state.userLogin.loading = false;
            state.userLogin.response = null;
            state.userLogin.hasError = true;
            state.userLogin.error = action.payload;
        })
            .addCase(getUserDetailsAction.pending, (state) => {
            state.userDetails.loading = true;
            state.userDetails.response = null;
            state.userDetails.hasError = false;
            state.userDetails.error = {};
        })
            .addCase(getUserDetailsAction.fulfilled, (state, action) => {
            state.userDetails.loading = false;
            state.userDetails.response = action.payload;
            state.userDetails.hasError = false;
            state.userDetails.error = {};
        })
            .addCase(getUserDetailsAction.rejected, (state, action) => {
            state.userDetails.loading = false;
            state.userDetails.response = null;
            state.userDetails.hasError = true;
            state.userDetails.error = action.payload;
        })
            .addCase(getUserOrganisationsAction.pending, (state) => {
            state.userOrganisations.loading = true;
            state.userOrganisations.response = null;
            state.userOrganisations.hasError = false;
            state.userOrganisations.error = {};
        })
            .addCase(getUserOrganisationsAction.fulfilled, (state, action) => {
            state.userOrganisations.loading = false;
            state.userOrganisations.response = action.payload;
            state.userOrganisations.hasError = false;
            state.userOrganisations.error = {};
        })
            .addCase(getUserOrganisationsAction.rejected, (state, action) => {
            state.userOrganisations.loading = false;
            state.userOrganisations.response = null;
            state.userOrganisations.hasError = true;
            state.userOrganisations.error = action.payload;
        })
            .addCase(userLoginV2Action.pending, (state) => {
            state.userLogin.loading = true;
            state.userLogin.response = null;
            state.userLogin.hasError = false;
            state.userLogin.error = {};
        })
            .addCase(userLoginV2Action.fulfilled, (state, action) => {
            state.userLogin.loading = false;
            state.userLogin.response = action.payload;
            state.userLogin.hasError = false;
            state.userLogin.error = {};
        })
            .addCase(userLoginV2Action.rejected, (state, action) => {
            state.userLogin.loading = false;
            state.userLogin.response = null;
            state.userLogin.hasError = true;
            state.userLogin.error = action.payload;
        })
            .addCase(getSiteListAction.pending, (state) => {
            state.userSiteList.loading = true;
            state.userSiteList.hasError = false;
            state.userSiteList.error = {};
        })
            .addCase(getSiteListAction.fulfilled, (state, action) => {
            state.userSiteList.loading = false;
            state.userSiteList.response = action.payload;
            state.userSiteList.hasError = false;
            state.userSiteList.error = {};
            // Cache the page data
            if (action.payload) {
                const pageNumber = Math.floor(action.payload.number);
                state.userSiteList.cachedPages[pageNumber] = action.payload;
                state.userSiteList.currentPage = pageNumber + 1;
            }
        })
            .addCase(getSiteListAction.rejected, (state, action) => {
            state.userSiteList.loading = false;
            state.userSiteList.response = null;
            state.userSiteList.hasError = true;
            state.userSiteList.error = action.payload;
        });
    },
});
export const { resetAuthSlice, getMapId, getSiteName, setSiteListFromCache } = authSlice.actions;
export default authSlice.reducer;
